module.exports = __webpack_public_path__ + "img/qrcode.9a941198.png";